"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AbstractDropdown = _interopRequireDefault(require("../../../AbstractDropdown"));
var _DropdownButton = require("../DropdownButton/DropdownButton");
var DropdownContainer = exports.DropdownContainer = function DropdownContainer(props) {
  var className = props.className,
    children = props.children,
    position = props.position,
    dropdownRef = props.dropdownRef,
    label = props.label,
    isInitialOpen = props.isInitialOpen;
  return /*#__PURE__*/_react["default"].createElement(StyledDropdown, {
    className: className,
    ref: dropdownRef,
    autoOpen: false,
    autoClose: false,
    position: position,
    headRenderer: function headRenderer() {
      var _dropdownRef$current;
      return /*#__PURE__*/_react["default"].createElement(_DropdownButton.DropdownButton, {
        label: label,
        isOpen: dropdownRef === null || dropdownRef === void 0 || (_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.state.isOpen,
        isFiltersMobile: false
      });
    },
    contentRenderer: function contentRenderer() {
      return children;
    },
    open: isInitialOpen
  });
};
var StyledDropdown = (0, _styledComponents["default"])(_AbstractDropdown["default"]).withConfig({
  displayName: "DesktopContainer__StyledDropdown",
  componentId: "sc-aok0zk-0"
})(["position:relative;", "{", " ", " z-index:20;margin-top:10px;position:absolute;background-color:var(--white);border-radius:var(--border-radius);min-width:280px;box-shadow:var(--box-shadow);::before{border-bottom:10px solid #fff;border-left:10px solid transparent;border-right:10px solid transparent;content:'';height:0;margin-left:-10px;position:absolute;top:-10px;width:0;}}"], _AbstractDropdown["default"].StyledContentContainer, function (_ref) {
  var position = _ref.position;
  return position === 'right' && "\n        left: 10px;\n\n        ::before {\n          left: 20px;\n        }\n      ";
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'center' && "\n        left: 50%;\n        transform: translateX(-50%);\n\n        ::before {\n          left: 50%;\n        }\n      ";
});